import React from "react";
import { Alert, Row, Col, Input } from "reactstrap";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import style from "./Trade.module.scss";
import {
  CounterpartySuggest,
  fetchCParties,
  ProductField,
  NumberField,
  SymbolField,
  TradingRoutes,
} from "../Trading/FormFields";
import { Field, Combobox, Switch } from "../Order/Field/Field";
import Side from "../Order/Field/Side";
import { getBaseAndPriceCurrencies } from "../../../utils";
import Booktype from "../Order/Field/Booktype";

export const EmptyOrders = () => (
  <div
    className="h5"
    style={{
      textAlign: "center",
      border: "solid 1px #d6d6d6",
      background: "white",
      padding: "15px",
    }}
  >
    No Orders
  </div>
);

export const AlertError = ({ error }) => {
  if (error == undefined) {
    return null;
  }

  return (
    <React.Fragment>
      <hr />
      <Alert color="danger" className={style.alert}>
        {error}
      </Alert>
    </React.Fragment>
  );
};

export const Number = ({ value, dataTypeDecimalName }) => (
  <span className={style.number}>
    {value === null ? "-" : <FormattedNumber value={value} dataTypeDecimalName={dataTypeDecimalName} />}
  </span>
);

export const FooterForm = ({ fields, errors, onChange, tradeRoutes, counterparties, isReadonlyTrade }) => (
  <Row>
    <Col lg={4}>
      <TradingRoutes
        value={fields.route}
        error={errors.route}
        onChange={(id) => onChange("route", { value: id })}
        tradeRoutes={tradeRoutes}
        disabled={isReadonlyTrade}
      />
    </Col>
    <Col lg={4}>
      <CounterpartySuggest
        value={fields.counterparty.name}
        //disabled={false}
        onChange={(v) =>
          onChange("counterparty", {
            values: { id: v.counterpartyId, name: v.counterpartyName },
          })
        }
        error={errors.counterparty}
        fetchItems={(v) => fetchCParties(v, counterparties)}
        disabled={isReadonlyTrade}
      />
    </Col>
    <Col lg={4}>
      <Field label={"Settlement Date (value date)"} error={errors.valueDate}>
        <Input
          type="date"
          placeholder={"Settlement date"}
          value={fields.valueDate}
          invalid={!!errors.valueDate}
          disabled={isReadonlyTrade}
          onChange={(e) => onChange("valueDate", { value: e.target.value })}
        />
      </Field>
    </Col>
  </Row>
);

export const HeaderForm = ({
  fields,
  errors,
  onChange,
  isNewTrade,
  isReadonlyTrade,
  tradeHasSelectedOrders,
  services,
  asset,
  booktypes
}) => {
  const isFX = fields.form == "Forex";
  const { baseCurrency, priceCurrency } = getBaseAndPriceCurrencies(
    fields.settlementCurrencies,
    fields.tradeCurrencySymbol,
    fields.settlementCurrencySymbol
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={3}>
          <div style={{ marginTop: "20px" }}>
            <Side
              readonly={!isNewTrade}
              side={fields.side}
              onChange={(e) => onChange("side", { value: e.OrderSide })}
            />
          </div>
        </Col>

        <Col lg={3}>
          <ProductField form={fields.form} onChange={onChange} disabled={!isNewTrade} />
        </Col>
        <Col lg={6}>
          {!isFX && (
            <div className={style.symbol}>
              <SymbolField
                label={"Asset"}
                error={errors.asset}
                form={fields.form}
                disabled={!isNewTrade}
                value={fields.asset}
                onChange={({ id, name }) => onChange("asset", { values: { id, name } })}
                services={services}
              />
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <NumberField
            tabIndex={0}
            value={parseFloat(fields.quantity)}
            label={"Quantity"}
            error={errors.quantity}
            disabled={isReadonlyTrade}
            onChange={(v) => onChange("quantity", { value: v })}
            dataTypeDecimalName="quantity"
          />
        </Col>
        <Col lg={3}>
          <NumberField
            tabIndex={0}
            value={parseFloat(fields.price)}
            label={
              isFX
                ? `Exchange Rate (${baseCurrency}/${priceCurrency})`
                : `Price (${fields.tradeCurrencySymbol})`
            }
            placeholder={isFX ? "Exchange Rate" : "Price"}
            error={errors.price}
            disabled={isReadonlyTrade}
            onChange={(v) => onChange("price", { value: v })}
          />
        </Col>

        <Col lg={3}>
          {isFX ? (
            <div className={style.symbol}>
              <SymbolField
                label={"Trade Currency"}
                error={errors.tradeCurrency}
                form={fields.form}
                disabled={!isNewTrade}
                value={{ id: fields.tradeCurrencyId, name: fields.tradeCurrencySymbol }}
                onChange={({ id, name }) => onChange("tradeCurrency", { values: { id, name } })}
                services={services}
              />
            </div>
          ) : (
            <Field label={"Trade Currency"} error={errors.tradeCurrencySymbol}>
              <Input type="text" placeholder="Trade Currency" value={fields.tradeCurrencySymbol} disabled />
            </Field>
          )}
        </Col>
        <Col lg={3}>
          <Field label={"Settlement Currency"} error={errors.settlementCurrencySymbol}>
            <Combobox
              value={fields.settlementCurrencyId}
              items={fields.settlementCurrencies}
              disabled={isReadonlyTrade || tradeHasSelectedOrders}
              invalid={!!errors.settlementCurrencySymbol}
              onChange={(v) => onChange("settlementCurrencyId", { value: v })}
              emptyLabel={"Settlement Currency"}
            />
          </Field>
        </Col>
      </Row>
      <Row>
        {!isFX &&
          fields.tradeCurrencySymbol !== "" &&
          fields.settlementCurrencySymbol !== "" &&
          fields.tradeCurrencySymbol !== fields.settlementCurrencySymbol && (
            <React.Fragment>
              <Col lg={2}>
                <Field label={`FX route`} error={errors.FXRoute}>
                  <Combobox
                    value={fields.FXRoute}
                    items={[
                      { id: "FXThroughCpty", description: "Through Cpty" },
                      { id: "FXThroughOrder", description: "Through FX order" },
                    ]}
                    disabled={isReadonlyTrade}
                    onChange={(v) => onChange("FXRoute", { value: v })}
                    emptyLabel={"FX route"}
                    invalid={!!errors.FXRoute}
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                  />
                </Field>
              </Col>
              <Col lg={2}>
                {fields.FXRoute == "FXThroughCpty" && (
                  <Field label={"Manual"}>
                    <Switch value={fields.manualFX} onChange={(v) => onChange("manualFX", { value: v })} />
                  </Field>
                )}
              </Col>
              <Col lg={3}>
                {fields.FXRoute == "FXThroughCpty" && (
                  <Field label={`FX ${baseCurrency}/${priceCurrency}`} error={errors.FX}>
                    <NumberFormatInput
                      type="text"
                      customInput={Input}
                      value={fields.FX || ""}
                      invalid={!!errors.FX}
                      onValueChange={(e) => {
                        onChange("FX", { value: e.value });
                      }}
                      disabled={isReadonlyTrade || !fields.manualFX}
                      placeholder={"FX"}
                      dataTypeDecimalName="currency"
                    />
                  </Field>
                )}
                {fields.FXRoute == "FXThroughOrder" && fields.FXRelatedOrderId && (
                  <Field label={`FX order`}>
                    <Input type="text" value={`#${fields.FXRelatedOrderId}`} disabled />
                  </Field>
                )}
              </Col>
            </React.Fragment>
          )}
        <Col lg={5}>
          <Field label={"Date time"} error={errors.date}>
            <Input
              type="datetime-local"
              step="1"
              placeholder={"Date time"}
              value={fields.date}
              invalid={!!errors.date}
              disabled={isReadonlyTrade}
              onChange={(e) => onChange("date", { value: e.target.value })}
              style={{ width: "225px" }}
            />
          </Field>
        {/* //  {(this.state.ui.userRole === "Trader" || (this.state.ui.userRole !== "Trader")) //&& //&& this.state.ui.mode !== Mode.EDIT)) && */}
        { booktypes &&
             <Booktype
              booktypes={booktypes}
              booktype={fields.booktype}
              balancetype={fields.balancetype}
              errors={{
                BookType: false,//errors.BookType,
                BalanceType: false//errors.BalanceType
              }}
              readonly={{
                BookType: isReadonlyTrade,
                BalanceType: isReadonlyTrade
              }}
              //onChange={(v) => onChange(dispatch, v)}
              onChange={(id) => onChange("booktype", { value: id.BookType })}
              onAccountChange={(id) => onChange("balancetype", { value: id.BalanceType })}

              //onAccountChange={(v) => onAccountChange(dispatch, v)}
            /> 
            }
           {/* // } */}
        </Col>
      </Row>
    </React.Fragment>
  );
};
